// extracted by mini-css-extract-plugin
export default {"main":"_623458671d","tit":"eb25c9cd16","maintitle":"_7722fa4300","ylw":"d8fc74d4f0","white":"_12cc925d87","mv_title":"d16f188812","mv_nc":"a1d94b4706","mv_in":"d9eb629967"};